import { render, staticRenderFns } from "./Combos.vue?vue&type=template&id=65a0eb87&"
import script from "./Combos.vue?vue&type=script&lang=js&"
export * from "./Combos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports